import React from 'react';


const MeetingsContent = (props: any) => {
    return <>meetings content coming soon!</>
}

export default MeetingsContent;